import React from 'react';
import { useIntl } from 'react-intl';
import { MdChevronRight } from 'react-icons/md';
import { Tooltip, TOOLTIP_PLACEMENT_BOTTOM, TOOLTIP_SIZE_MEDIUM } from '@aibuild/ui';
import { Anchor, Handle } from './SidebarExpandHandle.styled';

interface SidebarExpandHandleProps {
  readonly onExpand: () => void;
  readonly dataTestId: string;
}

const SidebarExpandHandle: React.FC<SidebarExpandHandleProps> = ({ onExpand, dataTestId }) => {
  const intl = useIntl();
  const label = intl.formatMessage({ id: 'nav.sidebar.expand', defaultMessage: 'Expand sidebar' });
  return (
    <Anchor>
      <Tooltip content={label} placement={TOOLTIP_PLACEMENT_BOTTOM} size={TOOLTIP_SIZE_MEDIUM} portal>
        <Handle type="button" onClick={onExpand} aria-label={label} data-testid={dataTestId}>
          <MdChevronRight size={16} aria-hidden="true" />
        </Handle>
      </Tooltip>
    </Anchor>
  );
};

export default SidebarExpandHandle;
